var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "v-card-text",
        { staticStyle: { "min-height": "396px" } },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "subheading font-weight-medium baseline" },
                [
                  _vm._v("\n        Include QA/QC sample data\n        "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "open-on-hover": "",
                        "open-delay": 400,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "clickable ml-2",
                                    attrs: { color: "primary" },
                                  },
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              info_outline\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-text", [
                            _vm._v(
                              "\n              Include data from QA/QC replicate samples.\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  staticClass: "mt-1 mb-4",
                  attrs: { disabled: _vm.disabled, "hide-details": "" },
                  model: {
                    value: _vm.reportOptions.includeQaQc,
                    callback: function ($$v) {
                      _vm.$set(_vm.reportOptions, "includeQaQc", $$v)
                    },
                    expression: "reportOptions.includeQaQc",
                  },
                },
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-radio", {
                            attrs: {
                              "hide-details": "",
                              color: "primary",
                              label: "Yes",
                              value: true,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c("v-radio", {
                            attrs: {
                              "hide-details": "",
                              color: "primary",
                              label: "No",
                              value: false,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "subheading font-weight-medium baseline" },
                [
                  _vm._v(
                    "\n        Include Internal EnviroData Analyte name\n        "
                  ),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "open-on-hover": "",
                        "open-delay": 400,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "clickable ml-2",
                                    attrs: { color: "primary" },
                                  },
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              info_outline\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-text", [
                            _vm._v(
                              "\n              Internal EnviroData names are unique analyte names that help us manage analytes and potential synonyms.\n              Display names are not unique and the internal EnviroData name will provide an indication of the\n              difference between repeating display names.\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  staticClass: "mt-1 mb-4",
                  attrs: { disabled: _vm.disabled, "hide-details": "" },
                  model: {
                    value: _vm.reportOptions.includeEnvirodataAnalyteName,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.reportOptions,
                        "includeEnvirodataAnalyteName",
                        $$v
                      )
                    },
                    expression: "reportOptions.includeEnvirodataAnalyteName",
                  },
                },
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-radio", {
                            attrs: {
                              color: "primary",
                              label: "Yes",
                              value: true,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c("v-radio", {
                            attrs: {
                              color: "primary",
                              label: "No",
                              value: false,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "subheading font-weight-medium baseline" },
                [
                  _vm._v("\n        Report format\n        "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "open-on-hover": "",
                        "open-delay": 400,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "clickable ml-2",
                                    attrs: { color: "primary" },
                                  },
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              info_outline\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-text", [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("strong", [_vm._v("Standard")]),
                              _vm._v(
                                " reports show analytes as rows —\n                this format is similar to most EnviroData reports.\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-2" }, [
                              _c("strong", [_vm._v("Wide")]),
                              _vm._v(
                                " reports show analytes as columns.\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [_vm._v("Long")]),
                              _vm._v(
                                " reports are easily parsed by programming languages such as R.\n              "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  staticClass: "mt-1 mb-4",
                  attrs: { disabled: _vm.disabled, "hide-details": "" },
                  model: {
                    value: _vm.reportOptions.reportFormat,
                    callback: function ($$v) {
                      _vm.$set(_vm.reportOptions, "reportFormat", $$v)
                    },
                    expression: "reportOptions.reportFormat",
                  },
                },
                [
                  _c(
                    "v-layout",
                    _vm._l(_vm.reportTypes, function (reportType, index) {
                      return _c(
                        "v-flex",
                        { key: `reportType-${index}` },
                        [
                          _c("v-radio", {
                            attrs: {
                              color: "primary",
                              value: reportType.value,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "font-weight-" },
                                          [_vm._v(_vm._s(reportType.name))]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "caption" }, [
                                          _vm._v(_vm._s(reportType.format)),
                                        ]),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.reportTypesMapping[_vm.reportOptions.reportFormat]
              .canGroupWorksheet
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "subheading font-weight-medium baseline",
                          },
                          [
                            _vm._v(
                              "\n            Group worksheet data by\n            "
                            ),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "offset-y": "",
                                  "open-on-hover": "",
                                  "open-delay": 400,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "clickable ml-2",
                                                attrs: { color: "primary" },
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n                  info_outline\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3798373842
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  [
                                    _c("v-card-text", [
                                      _vm._v(
                                        "\n                  As an example, if "
                                      ),
                                      _c("strong", [
                                        _vm._v("Stations and Media Types"),
                                      ]),
                                      _vm._v(
                                        " is selected,\n                  then a station will have a spreadsheet for each of its media types.\n                "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-radio-group",
                          {
                            ref: "organizeWorksheetGroup",
                            staticClass: "mt-1 mb-4",
                            attrs: {
                              disabled: _vm.disabled,
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.reportOptions.organizeWorksheetBy,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.reportOptions,
                                  "organizeWorksheetBy",
                                  $$v
                                )
                              },
                              expression: "reportOptions.organizeWorksheetBy",
                            },
                          },
                          [
                            _c(
                              "transition-group",
                              {
                                staticClass: "layout",
                                attrs: { name: "fade", tag: "div" },
                              },
                              _vm._l(
                                _vm.reportTypesMapping[
                                  _vm.reportOptions.reportFormat
                                ].reportGroupings,
                                function (reportGrouping, index) {
                                  return _c(
                                    "v-flex",
                                    { key: `reportGrouping-${index}` },
                                    [
                                      _c("v-radio", {
                                        key: reportGrouping.name,
                                        attrs: {
                                          color: "primary",
                                          label: reportGrouping.name,
                                          value: reportGrouping.value,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.reportTypesMapping[_vm.reportOptions.reportFormat]
                        .canIncludeStatSummary
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "subheading font-weight-medium baseline",
                                },
                                [
                                  _vm._v(
                                    "\n              Include statistical data summary\n              "
                                  ),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        "offset-y": "",
                                        "open-on-hover": "",
                                        "open-delay": 400,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "clickable ml-2",
                                                      attrs: {
                                                        color: "primary",
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                    info_outline\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        801854674
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        [
                                          _c("v-card-text", [
                                            _vm._v(
                                              "\n                    Adds a table at the bottom of every spreadsheet that includes summary statistics for each analyte.\n                    "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                    Statistics include: min, max, mean, median, standard deviation, standard error, sample size,\n                    number of non-detects, and percentage of non-detects.\n                    "
                                            ),
                                            _c("br"),
                                            _c("br"),
                                            _vm._v(
                                              "\n                    Mean, median, standard deviation and standard error are only calculated if the percentage of\n                    non-detects is less than 50%.\n                  "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-1 mb-4",
                                  attrs: {
                                    disabled: _vm.disabled,
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.reportOptions.includeSummaryTab,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.reportOptions,
                                        "includeSummaryTab",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "reportOptions.includeSummaryTab",
                                  },
                                },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              color: "primary",
                                              label: "Yes",
                                              value: true,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              color: "primary",
                                              label: "No",
                                              value: false,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }